import { render, staticRenderFns } from "./SettingsInvoice.vue?vue&type=template&id=3b9fddb3&scoped=true&"
import script from "./SettingsInvoice.vue?vue&type=script&lang=ts&"
export * from "./SettingsInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsInvoice.vue?vue&type=style&index=0&id=3b9fddb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9fddb3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b9fddb3')) {
      api.createRecord('3b9fddb3', component.options)
    } else {
      api.reload('3b9fddb3', component.options)
    }
    module.hot.accept("./SettingsInvoice.vue?vue&type=template&id=3b9fddb3&scoped=true&", function () {
      api.rerender('3b9fddb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/settings/SettingsInvoice.vue"
export default component.exports